import { render, staticRenderFns } from "./BaseButtonLight.vue?vue&type=template&id=f827ec1a&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f827ec1a')) {
      api.createRecord('f827ec1a', component.options)
    } else {
      api.reload('f827ec1a', component.options)
    }
    module.hot.accept("./BaseButtonLight.vue?vue&type=template&id=f827ec1a&", function () {
      api.rerender('f827ec1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseButtonLight.vue"
export default component.exports